import React from 'react'
import Loader from '../../../components/global/Loader'
import BreadCrumb from '../BreadCrumb/BreadCrumb'

const LoadingScreen = () => {
    return (
        <div className='min-height-600'>
            <BreadCrumb headerTitle={'Loading'} headerName={'Loading'} headerContent={'Loading'} />
            <div>
                <div className="container">
                    <div className="text-center my-3">
                        <Loader/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoadingScreen